import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../../focus-selector.i18n';
import { Row } from '../../grid/experimental.grid';
import { selectTemplate } from '../../grid/reusable-grid.function';
import { GridSortClickEvent } from '../../grid/reusable-grid.model';
import {
    ColumnID,
    FocusHistoryGrid,
} from '../../model/focus-history.grid.model';
import { FocusSelectorFocusForPerformer } from '../../model/focus-selector-focus-for-performer.model';

@Component({
    selector: 'active-for-performer-grid',
    templateUrl: './active-for-performer-grid.component.html',
    host: { class: 'active-for-performer-grid' },
})
export class ActiveForPerformerGridComponent {
    @Input() gridData: FocusHistoryGrid<FocusSelectorFocusForPerformer>;
    @Output() selectRow: EventEmitter<Row['id']>;
    @Output() sortGrid: EventEmitter<GridSortClickEvent>;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _ColumnID = ColumnID;
    /** @private */ _selectTpl = selectTemplate;

    constructor() {
        this.selectRow = new EventEmitter();
        this.sortGrid = new EventEmitter();
    }

    /** @private */ _selectRow(selectedRows: Set<Row['id']>): void {
        this.selectRow.emit(Array.from(selectedRows)[0]);
    }
}
